import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RoamingDataApiRoaming } from '@api-roaming/models/roaming-data-api-roaming';
import { AppSettingsService } from '@core/services/app-settings.service';
import { LocalStorage } from '@core/storage/local-storage';
import { StorageKeys } from '@core/storage/storage.keys';
import { DEFAULT_LANG } from '@shared/constants';
import { Observable } from 'rxjs';


/**
 * Interceptor for client api requests
 */
@Injectable()
export class ClientApiInterceptor implements HttpInterceptor {
    @LocalStorage(StorageKeys.SystemLocale)
    public languageCodeFromStorage: string;

    @LocalStorage(StorageKeys.AuthUser)
    public storageUserRoaming: string;

    readonly #appSettingsService: AppSettingsService = inject(AppSettingsService);

    /**
     *
     * @param request - request
     * @param next - request handler
     */
    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const params: Record<string, string> = { lang: this.languageCodeFromStorage || DEFAULT_LANG };
        const user: RoamingDataApiRoaming = this.storageUserRoaming ? JSON.parse(this.storageUserRoaming) : null;

        /** Client api service requests */
        if (request.url.includes('/api/v3/') && !request.headers.get('Api-Scheme')) {
            if (user) {
                const cloneRequest: HttpRequest<unknown> = request.clone({
                    url: user.serviceUrl + request.url,
                    setHeaders: {
                        authToken: user.clientId,
                    },
                    setParams: params,
                });

                return next.handle(cloneRequest);
            } else {
                return next.handle(request);
            }
            /** Roaming api service requests */
        } else if (request.url.includes('/api/Roaming/') && !request.headers.get('Api-Scheme')) {
            const cloneRequest: HttpRequest<unknown> = request.clone({
                url: 'https://' + this.#appSettingsService.getProp('APP_SETTINGS_API_URL') + request.url,
                setParams: params,
            });

            return next.handle(cloneRequest);
            /** Another requests */
        } else {
            return next.handle(request);
        }

    }
}
